import { gql } from '@apollo/client'

export const BRAND_GEOGRAPHY = gql`
  query BrandGeographyQuery($input: BrandGeographyInput!) {
    brandGeography(input: $input) {
      results {
        latitude
        longitude
        quantity
        storeName
        brand {
          name
        }
      }
    }
  }
`
